import { menuGroup, menuItem } from "modules/helpers";

// components
import NavigationLogger from "./NavigationLogger.doc";
import PageLogger from "./PageLogger.doc";

const components = [
  menuItem("<NavigationLogger/>", "navigation-logger", NavigationLogger),
  menuItem("<PageLogger/>", "page-logger", PageLogger),
];

// functions
import LogError from "./LogError.doc";
import LogNavigation from "./LogNavigation.doc";
import SetUserIdentity from "./SetUserIdentity.doc";
import ClearUserIdentity from "./ClearUserIdentity.doc";

const functions = [
  menuItem("logError", "log-error", LogError),
  menuItem("logNavigation", "log-navigation", LogNavigation),
  menuItem("setUserIdentity", "set-user-identity", SetUserIdentity),
  menuItem("clearUserIdentity", "clear-user-identity", ClearUserIdentity),
];

// configuration
import EnableCustomLogger from "./EnableCustomLogger.doc";
import EnableSentryLogger from "./EnableSentryLogger.doc";
import SetLoggingModuleOptions from "./SetLoggingModuleOptions.doc";
import SetLoggingOptions from "./SetLoggingOptions.doc";

const configuration = [
  menuItem("enableCustomLogger", "enable-custom-logger", EnableCustomLogger),
  menuItem("enableSentryLogger", "enable-sentry-logger", EnableSentryLogger),
  menuItem(
    "setLoggingModuleOptions",
    "set-logging-module-options",
    SetLoggingModuleOptions
  ),
  menuItem("setLoggingOptions", "set-logging-options", SetLoggingOptions),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Functions", "functions", functions),
  menuGroup("Configuration", "configuration", configuration),
];
